<div class="widget-header flex flex-row place-content-between items-center mb-5">
  <h2 class="text-2xl font-medium flex items-center gap-1">
    <ng-container i18n>Out of office</ng-container>
    <button
      mat-icon-button
      *ngIf="!isOtherUser || (AnyUserProfile | can : 'vacation.update')"
      (click)="vacationDialog()"
      class="flex justify-center items-center hover:!bg-transparent focus:!bg-transparent"
    >
      <div class="relative !h-[18px] !w-[18px] !text-white !bg-gray-600 rounded-2xl shadow-small">
        <mat-icon class="material-icons-outlined absolute top-[-3px] left-[-3px]">add_circle</mat-icon>
      </div>
    </button>
  </h2>
</div>

<section class="vacations">
  <mat-card *ngFor="let vacation of vacations$ | async; let i = index" class="vacation mb-2 !rounded-md !shadow-sm">
    <mat-card-content>
      <div class="vacation__header flex flex-row place-content-between items-center">
        <!-- Title -->
        <div class="flex-1 pr-4 overflow-hidden">
          <h1 class="font-medium overflow-hidden text-ellipsis whitespace-nowrap">{{ vacation.title }}</h1>
        </div>
        <!-- Duration -->
        <div class="vacation__duration flex-[1.7] text-gray-500">
          <span>{{ vacation.from | date : 'dd MMMM yyyy' }}</span>
          <span class="separator mx-2">-</span>
          <span>{{ vacation.to | date : 'dd MMMM yyyy' }}</span>
        </div>
        <!-- Out of office message -->
        <div class="vacation__message flex-[2] text-gray-500 pr-4 overflow-hidden">
          <p class="overflow-hidden text-ellipsis whitespace-nowrap">{{ vacation.message | stripHtml }}</p>
        </div>
        <!-- Actions -->
        <div class="vacation__actions flex flex-row flex-[0.6] justify-end items-center mt-[-16px] mb-[-16px]">
          <button *ngIf="!isOtherUser && (vacation | canEditVacation)" mat-icon-button matTooltip="Edit vacation" (click)="vacationDialog(vacation, i)" class="vacation__edit mr-[-8px]">
            <mat-icon class="material-icons-outlined">edit</mat-icon>
          </button>
          <button *ngIf="!isOtherUser" mat-icon-button matTooltip="Delete vacation" (click)="deleteDialog(i)">
            <mat-icon class="vacation__delete material-icons-outlined">delete</mat-icon>
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</section>
